import { Button, Tag } from "antd";
import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import Style from "./style";
import useAmpsMap from "./hook";
import AnalysisWidget from "../../../../../../Analysis/widget";
import ComponentWithFocus from "../../../../../../Analysis/components/component-with-focus";
import { getTagColor } from "../../../../../../../helpers/user/tagColor";

export default function AmpsMap({ data = [], options }) {
  const mappedData = useMemo(() => data.filter((d) => d?.coordinates?.lat && d?.coordinates?.lng).map((d) => {
    const country = options.countries.find((v) => v.value === d.country);

    return {
      ...d,
      country: country ? country.label : d.countries,
    };
  }), [data, options]);

  const getMineral = (data) => {
    const mineral = options.minerals.find((v) => v.value === data);
    return mineral?.label || data;
  };

  const container = useRef();
  const { t } = useTranslation();
  const [closed, setClosed] = useState(false);
  const { onCloseSider, activeMarker } = useAmpsMap({ container, data: mappedData, options });

  const actions = useMemo(() => ({
    closed,
    setClosed,
  }), [closed]);

  const selectedAmp = useMemo(() =>
    activeMarker ? mappedData.find((d) => d.id === activeMarker) : null, [activeMarker, mappedData]);

  return (
    <AnalysisWidget
      className="with-border-header no-p-body"
      title={t('AMPs Map')}>
      <ComponentWithFocus actions={actions}>
        <Style>
          <div className="map-cont" ref={container} />

          {!!selectedAmp && (
            <div className="sider flex flex-column">
              <div className="map-sider-header mb-4">
                <div className="flex justify-content-between mb-3">
                  <div className="flex flex-column justify-content-center">
                    <h3>{selectedAmp.name}</h3>
                  </div>
                  <div className="flex flex-column justify-content-center">
                    <CloseOutlined onClick={onCloseSider} className="cursor-pointer" />
                  </div>
                </div>

                {!!selectedAmp.product ? (
                  <Tag color={getTagColor(selectedAmp.product)} className="mb-4">
                    {t(getMineral(selectedAmp.product))}
                  </Tag>
                ) : <div className="mb-6" />}
              </div>

              <div className="map-sider-body flex-1 flex flex-column">
                <div className="flex flex-column">
                  <label>{t('Country')}</label>
                  <span>{selectedAmp.country || '--'}</span>
                </div>
                <div className="flex flex-column">
                  <label>{t('Program')}</label>
                  <span>
                    {
                      selectedAmp.programs && Array.isArray(selectedAmp.programs) && selectedAmp.programs.length
                        ? selectedAmp.programs.map((p) => (
                          <Tag key={p.id}>{p.name}</Tag>
                        ))
                        : '--'
                    }</span>
                </div>
                <div className="flex flex-column">
                  <label>{t('Investment')}</label>
                  <span>{selectedAmp.investment || '--'}</span>
                </div>
                <div className="flex flex-column">
                  <label>{t('Workers')}</label>
                  <span>{selectedAmp.workers || '--'}</span>
                </div>
              </div>

              <a href={`/app/tif/analysis/amp/${selectedAmp.id}`} target="_blank" className="flex" rel="noreferrer">
                <Button type="primary" className="flex-1">{t('Mine Details')}</Button>
              </a>
            </div>
          )}
        </Style>
      </ComponentWithFocus >
    </AnalysisWidget>
  );
}
